import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-185d8592"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "imgView"
};
const _hoisted_2 = {
  class: "cut"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "font-size": "14px",
    "color": "#777",
    "margin-top": "20px"
  }
}, "头像预览", -1));
const _hoisted_5 = {
  class: "test-button"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "btn",
  for: "uploads"
}, "上传", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_VueCropper = _resolveComponent("VueCropper");
  const _component_a_divider = _resolveComponent("a-divider");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_VueCropper, {
    ref: "cropper",
    img: $data.option.img,
    "output-size": $data.option.size,
    "output-type": $data.option.outputType,
    info: true,
    full: $data.option.full,
    fixed: $data.fixed,
    "fixed-number": $data.fixedNumber,
    "can-move": $data.option.canMove,
    "can-move-box": $data.option.canMoveBox,
    "fixed-box": $data.option.fixedBox,
    original: $data.option.original,
    "auto-crop": $data.option.autoCrop,
    "auto-crop-width": $data.option.autoCropWidth,
    "auto-crop-height": $data.option.autoCropHeight,
    "center-box": $data.option.centerBox,
    onRealTime: $options.realTime,
    high: $data.option.high,
    mode: "contain",
    "max-img-size": $data.option.max
  }, null, 8, ["img", "output-size", "output-type", "full", "fixed", "fixed-number", "can-move", "can-move-box", "fixed-box", "original", "auto-crop", "auto-crop-width", "auto-crop-height", "center-box", "onRealTime", "high", "max-img-size"])]), _createElementVNode("div", {
    class: "show-preview",
    style: _normalizeStyle({
      width: $data.option.autoCropWidth + 'px',
      height: $data.option.autoCropHeight + 'px',
      margin: '5px'
    })
  }, [_createElementVNode("div", {
    style: _normalizeStyle($data.previews.div),
    class: "ovf"
  }, [_createElementVNode("img", {
    src: $data.previews.url,
    style: _normalizeStyle($data.previews.img)
  }, null, 12, _hoisted_3)], 4), _hoisted_4], 4)]), _createVNode(_component_a_divider), _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("input", {
    type: "file",
    id: "uploads",
    style: {
      "position": "absolute",
      "clip": "rect(0 0 0 0)"
    },
    accept: "image/png, image/jpeg, image/gif, image/jpg",
    onChange: _cache[0] || (_cache[0] = $event => $options.uploadImg($event, 1))
  }, null, 32), _createElementVNode("a", {
    onClick: _cache[1] || (_cache[1] = $event => $options.down('base64')),
    class: "btn",
    style: {
      "margin-left": "20px"
    }
  }, "保存")])], 64);
}